import * as React from 'react';
import { renderTextWithFootnotesReferencesV2 } from '../footnotes';
import { cleanupEmissionConsumptionMarkup } from '../utils';
const addFootnotesAndCleanup = (text) => {
    if (!text)
        return '';
    return renderTextWithFootnotesReferencesV2(cleanupEmissionConsumptionMarkup(text));
};
export function ConsumptionAndEmission({ consumptionAndEmission }) {
    const consumption = addFootnotesAndCleanup(consumptionAndEmission?.consumption);
    const emissionCO2 = addFootnotesAndCleanup(consumptionAndEmission?.emissionCO2);
    const co2Class = addFootnotesAndCleanup(consumptionAndEmission?.co2Class);
    const dischargedConsumption = addFootnotesAndCleanup(consumptionAndEmission?.dischargedConsumption);
    const dischargedCO2Class = addFootnotesAndCleanup(consumptionAndEmission?.dischargedCO2Class);
    return (React.createElement("span", { style: { display: 'block' } },
        consumption,
        emissionCO2 && React.createElement("span", null,
            "; ",
            emissionCO2),
        co2Class && React.createElement("span", null,
            "; ",
            co2Class),
        dischargedConsumption && React.createElement("span", null,
            "; ",
            dischargedConsumption),
        dischargedCO2Class && React.createElement("span", null,
            "; ",
            dischargedCO2Class)));
}
//# sourceMappingURL=ConsumptionAndEmission.js.map